import { Capacitor, registerPlugin } from "@capacitor/core";

const NativeBadge = registerPlugin("NativeBadge");
let queue = Promise.resolve();

export function setApplicationBadge(count, { clearOnLogout = false } = {}) {
  if (Capacitor.getPlatform() !== "ios" || !Capacitor.isPluginAvailable("NativeBadge")) {
    return Promise.resolve();
  }
  const value = Number(count);
  if (!Number.isFinite(value)) return Promise.resolve();
  // Serialize updates so a slow earlier write cannot overwrite the new count.
  queue = queue.catch(() => {}).then(() => (
    NativeBadge.setCount({ count: Math.max(0, Math.floor(value)), clearOnLogout })
  ));
  return queue;
}
